import { Controller } from 'react-hook-form';
import { useState } from 'react';
import copy from 'copy-to-clipboard';
import SidepanelDefaultRow from '../side-panel/side-panel-default-row';
import InputText from '../inputs/input-text';
import { RowProps } from './types';
import IconCopy from '../icons/copy-two';
import IconInfo from '../icons/hint';

import styles from './transaction.module.css';

let timeout: NodeJS.Timeout;

export default function SidepanelTextRow({
  title,
  name,
  value,
  control,
  enableEdit,
  placeholder,
  children,
  borderless = false,
  error,
  disabled,
  fieldValue,
  setFieldValue,
  tabIndex,
  isFixedExchangeAmount,
  exchangeFieldType,
  isCreate,
  calculateTransactionRatesByIdAction,
  copyEnabled,
  copyValue,
  withHint,
  hintText,
  rightHint,
  smallHintWidth,
  setValue,
  hasExternalAccountValue,
  getFieldValue,
  onFocus,
  suffix,
  suffixClassName,
}: RowProps): React.JSX.Element {
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    setCopyIsSuccess(true);
    copy(copyValue as string);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  let content;

  if (enableEdit) {
    content = (
      <Controller
        name={name}
        control={control}
        rules={{ required: false }}
        defaultValue={value}
        render={({ field }) => (
          <>
            {withHint && hintText && (
              <div className={styles.exchangeTitleWrapper}>
                <div className={styles.exchangeTitle}>{title}</div>
                <div className={styles.profitHint}>
                  <IconInfo />
                  <div
                    className={`${styles.hint} ${
                      rightHint ? styles.rightHint : ''
                    }  ${smallHintWidth ? styles.smallHintWidth : ''}`}
                  >
                    {hintText}
                  </div>
                </div>
              </div>
            )}

            <InputText
              title={withHint && hintText ? '' : title}
              name={name}
              value={fieldValue || field.value}
              tabIndex={tabIndex}
              onChange={(e) => {
                if (setFieldValue) {
                  clearTimeout(timeout);

                  setFieldValue(e.target.value);

                  if (e.target.value) {
                    timeout = setTimeout(() => {
                      field.onChange(
                        isFixedExchangeAmount
                          ? Number(e.target.value)
                          : e.target.value,
                      );

                      if (
                        !isCreate &&
                        calculateTransactionRatesByIdAction &&
                        exchangeFieldType
                      ) {
                        calculateTransactionRatesByIdAction(
                          {
                            exchangeActualRate:
                              exchangeFieldType === 'rate'
                                ? Number(e.target.value)
                                : undefined,
                            exchangeMarginPercent:
                              exchangeFieldType === 'margin'
                                ? Number(e.target.value)
                                : undefined,
                            inverseActualRate:
                              exchangeFieldType === 'inversed-rate'
                                ? Number(e.target.value)
                                : undefined,
                          },
                          exchangeFieldType,
                        );
                      }
                    }, 400);
                  } else if (!e.target.value.length) {
                    clearTimeout(timeout);
                    field.onChange('');
                  }
                } else {
                  field.onChange(e);

                  if (getFieldValue) {
                    getFieldValue(e.target.value);
                  }
                }

                if (setValue && hasExternalAccountValue) {
                  setValue('pspIntegrationAccountId', undefined);
                }
              }}
              onFocus={() => onFocus && onFocus()}
              placeholder={placeholder as string}
              className={`${borderless ? 'borderless' : ''} `}
              suffix={suffix}
              suffixClassName={suffixClassName}
              error={error}
              disabled={disabled}
            />
          </>
        )}
      />
    );
  } else {
    content = children || value;
  }

  return (
    <SidepanelDefaultRow
      title={enableEdit ? undefined : title}
      valueClassName={`${copyEnabled && enableEdit ? styles.rowWithCopy : ''} ${
        copyEnabled && !enableEdit ? styles.readCopyButtonWrapper : ''
      }`}
    >
      {content}
      {copyEnabled && (
        <>
          {enableEdit && (
            <button
              type="button"
              className={`${styles.copyButton} ${
                styles.autocompleteCopyButton
              } ${copyIsSuccess ? styles.success : ''}`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
          {!enableEdit && (
            <button
              type="button"
              className={`${styles.readCopyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
        </>
      )}
    </SidepanelDefaultRow>
  );
}
